import { useTranslation } from 'react-i18next';
import { useMyOpenTasks } from '@/api/queries/useMyOpenTasks';
import { OpenTasksTable } from './OpenTasksTable';

/**
 * The "Aufgaben" block of "Meine Aufgaben": shown while loading and while the
 * caller has open tasks, gone once there are none — like the page's other
 * blocks, so an empty section never pushes the all-done state down.
 */
export function MyOpenTasksSection() {
  const { t } = useTranslation();
  const { data, isLoading } = useMyOpenTasks();

  const tasks = data ?? [];
  if (!isLoading && tasks.length === 0) return null;

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-lg font-semibold leading-6">{t('tasks.title')}</h2>
        <p className="mt-1 text-sm font-normal leading-5 text-gray-8">{t('tasks.description')}</p>
      </div>
      <OpenTasksTable tasks={tasks} isLoading={isLoading} enableUrlState />
    </div>
  );
}
